import { Link } from 'react-router-dom'
import { ExitIcon } from './icons'
import { keycloak } from '../lib'
import { AppBar } from '@tomra/design-system-react/app-bar'
import { Container } from '@tomra/design-system-react/container'
import { Button } from '@tomra/design-system-react/button'
import { TomraArrow } from '@tomra/design-system-react/tomra-arrow'
import { AppBarNavLink } from '@tomra/design-system-react/app-bar-nav-link'

export const Header = () => {
  function logout() {
    keycloak.logout()
  }

  return (
    <AppBar position="sticky">
      <Container className="flex flex-1 justify-between">
        <Link to="/" className="flex items-center gap-8">
          <TomraArrow variant="color" height={32} width={32} />
          <span className="text-xl font-medium">Charity Manager</span>
        </Link>
        <div className="flex items-center gap-4">
          <AppBarNavLink active asChild>
            <Link to="/charities">Charities</Link>
          </AppBarNavLink>
          <Button onClick={logout} variant="outline" size="sm" className={'gap-2'}>
            <ExitIcon color="black" width="1rem" height="1rem" />
            Logout
          </Button>
        </div>
      </Container>
    </AppBar>
  )
}
